import * as React from 'react';
import { Grid, GridColumn } from 'telia-front-react';
const TvChannelComparisonChannels = (props) => {
    const channelsLength = props.channelInclusions.length;
    const renderIncludedChannel = (channel, index) => (React.createElement(GridColumn, { key: index, border: ['bottom-xs'], width: ['xs', 'sm-3'] }, channel.title));
    const renderExcludedChannel = (channel, index) => {
        const packageName = `${props.translate(`tvChannelComparison.packageName.${props.selectedPackage}`)}`;
        return (React.createElement(GridColumn, { key: index, border: ['bottom-xs'], width: ['xs', 'sm-3'] },
            React.createElement("p", { className: "sr-only" }, props.translate('tvChannelComparison.channel.notIncluded', {
                channel: channel.title,
                packet: packageName,
            })),
            React.createElement("p", { className: "text-inactive", "aria-hidden": true }, channel.title)));
    };
    const addChannel = (channels, index, shownChannels) => {
        const channel = shownChannels[index];
        if (channel) {
            const isIncluded = channel.includedInProducts.includes(props.selectedPackage);
            channels.push(isIncluded ? renderIncludedChannel(channel, index) : renderExcludedChannel(channel, index));
        }
    };
    const getShownChannels = () => {
        return props.showAllChannels
            ? props.channelInclusions
            : props.channelInclusions.filter((channel) => channel.includedInProducts.includes(props.selectedPackage));
    };
    const renderChannels = (columns) => {
        const channels = [];
        const shownChannels = getShownChannels();
        if (columns === 2) {
            const columnLength = Math.ceil(channelsLength / 2);
            for (let index = 0; index < columnLength; index++) {
                addChannel(channels, index, shownChannels);
                addChannel(channels, index + columnLength, shownChannels);
            }
            return channels;
        }
        const columnLength = Math.ceil(channelsLength / 4);
        for (let index = 0; index < columnLength; index++) {
            addChannel(channels, index, shownChannels);
            addChannel(channels, columnLength + index, shownChannels);
            addChannel(channels, 2 * columnLength + index, shownChannels);
            addChannel(channels, 3 * columnLength + index, shownChannels);
        }
        return channels;
    };
    return (React.createElement(Grid, { horizontalGutter: "medium", verticalGutter: "small", borderWeight: "thin", element: "ul" }, renderChannels(props.columns)));
};
export default TvChannelComparisonChannels;
